import * as React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import $ from "jquery";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// import TurnRightIcon from "@mui/icons-material/TurnRight";
import {
  Aria,
  Vdara,
  Bellagio,
  ParkMGM,
  TCOLV,
  DistrictHighlight,
  Nomad,
} from "../list/listItems";
import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  NOMAD,
  DISTRICT_HIGHLIGHTS,
} from "../scripts/core/constants";
import { useStoreDollHouseMap } from "../store";
import SvglocationIcon from "./location-Icon";
import { shallow } from "zustand/shallow";
import {
  handleMouseEnterPoupHiding,
  resetAllMapPathSvg,
  setDollhouseMap,
} from "../components/customEvents.js";
import { __setCameraZoom } from "../components/DollhouseMapContainer";

let DrawerLeft = ({ name, position }) => {
  const theme = useTheme();

  let _xs = useMediaQuery(theme.breakpoints.only("xs"));
  let _sm = useMediaQuery(theme.breakpoints.only("sm"));

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      updatePOIPointAreaSelection: state.updatePOIPointAreaSelection,
      highlightPOIAreaSelection: state.highlightPOIAreaSelection,
      currentCosmoPolitanLevel: state.currentCosmoPolitanLevel,
      updateMapAreaSelection: state.updateMapAreaSelection,
    }),
    shallow
  );

  let listItemName;
  if (name === ARIA) listItemName = Aria;
  if (name === VDARA) listItemName = Vdara;
  if (name === BELLAGIO) listItemName = Bellagio;
  if (name === PARK_MGM) listItemName = ParkMGM;
  if (name === THE_COSMOPOLITAN) listItemName = TCOLV;
  if (name === NOMAD) listItemName = Nomad;
  if (name === DISTRICT_HIGHLIGHTS) listItemName = DistrictHighlight;

  const handleDropdownClick = (val) => {
    __setCameraZoom(val.map);

    if (dollhouseStore.currentCosmoPolitanLevel === "cosmo_level_4") {
      dollhouseStore.updateMapAreaSelection(THE_COSMOPOLITAN);
    }
    dollhouseStore.highlightPOIAreaSelection(val);
  };

  const handleMouseEnter = () => {
    handleMouseEnterPoupHiding();
  };

  React.useEffect(() => {
    if (_xs || _sm) {
    } else {
      let element = document.getElementById(name + "_names");

      if (element) {
        let rect = element.getBoundingClientRect();
        let positionFromTop = rect.top;
        document.getElementById("sidebar-list-div").style.maxHeight = "100%";
        let reactHeight =
          document.getElementById("sidebar-list-div").clientHeight;
        // console.log(positionFromTop, reactHeight);
        // console.log(window.innerHeight);
        // if (reactHeight < 190) {
        //   positionFromTop = window.innerHeight - document.getElementById("sidebar-list-div").clientHeight;
        // } else {
        if (position + reactHeight >= window.innerHeight) {
          let diff = position + reactHeight - window.innerHeight;
          if (reactHeight < 190) {
            positionFromTop =
              window.innerHeight -
              document.getElementById("sidebar-list-div").clientHeight;
          } else {
            document.getElementById("sidebar-list-div").style.maxHeight =
              reactHeight - diff + 16 + "px";
            // console.log(
            //   document.getElementById("sidebar-list-div").clientHeight,
            //   "clientHeight"
            // );
            positionFromTop =
              window.innerHeight -
              document.getElementById("sidebar-list-div").clientHeight;
          }
        }
        // }
        let divheight =
          document.getElementById("sidebar-list-div").clientHeight;
        document.getElementById("sidebar-list-div").style.top =
          positionFromTop + "px";
      }
    }
  }, [name]);

  return (
    <>
      <List
        onMouseEnter={handleMouseEnter}
        sx={{
          "& .MuiListItemText-root": { color: "#FFFFFF" },
          "&:hover": { color: "#BDA770" },
          "& span.MuiTypography-root": {
            fontSize: 13,
            fontFamily: "'Trade Gothic LT Std', sans-serif",
            fontWeight: "initial",
          },
        }}
      >
        {listItemName !== undefined &&
          listItemName.map((text, index) => (
            <ListItem
              key={text.name}
              disablePadding
              onClick={() => {
                //  if (!text.isActive) {
                handleDropdownClick(text);
                //}
              }}
              sx={{
                margin: "6px 0",
                "&:hover": { color: "#BDA770" },
              }}
              // onMouseEnter={onMouseEnter}
              // onMouseLeave={this.onMouseLeave}
            >
              <IconButton
                type="button"
                sx={{
                  p: "3px 8px",
                }}
                aria-label="search"
                className={"disable-hidden-sidebar-list"}
              >
                <SvglocationIcon></SvglocationIcon>
              </IconButton>

              <ListItemButton
                sx={{
                  paddingLeft: "0px",
                  paddingTop: "3.5px",
                  paddingBottom: "3.5px",
                }}
              >
                <ListItemText
                  primary={text.name}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#BDA770";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "";
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </>
  );
};

function SidebarSlideMenu({ value, position }) {
  return <DrawerLeft name={value} position={position} />;
}
export { SidebarSlideMenu };
